import { CaretRight, X } from '@phosphor-icons/react'
import clsx from 'clsx'
import Image from 'next/image'
import Link from 'next/link'
import { usePathname } from 'next/navigation'
import { useEffect, useState } from 'react'
import { BookTrialLessonButtonBlock } from '@/src/@types/statamic'
import CalenderIllustration from '@/src/blocks/BookTrialLessonButton/calendar.png'
import Button from '@/src/components/core/Button'
import useWindowScrolled from '@/src/hooks/useWindowScrolled'

export default function Component({ link }: BookTrialLessonButtonBlock) {
  const [showBookTrialLesson, setShowBookTrialLesson] = useState(true)
  const pathname = usePathname()

  useEffect(() => {
    setShowBookTrialLesson(true)
  }, [pathname])

  const scrolled1 = useWindowScrolled(600)
  const scrolled2 = useWindowScrolled(2400)

  return (
    <>
      <div
        className={clsx(
          'insert-x-0 fixed bottom-0 z-50 w-full origin-bottom border-t border-gray-150 bg-gray-50/90 px-5 py-4 backdrop-blur-xs transition-all duration-500 md:right-3 md:bottom-3 md:left-auto md:w-70 md:rounded-2xl md:border md:p-6 md:pt-16',
          {
            'pointer-events-none translate-y-full opacity-0': !scrolled1,
            'translate-y-0 opacity-100': scrolled1 && !scrolled2,
            'pointer-events-none translate-y-1/2 opacity-0 md:pointer-events-auto md:translate-y-0 md:opacity-100':
              scrolled2,
            'md:hidden': !showBookTrialLesson,
          }
        )}
      >
        <button
          className="absolute top-1 right-1 hidden p-2 md:block"
          onClick={() => setShowBookTrialLesson(false)}
        >
          <X size={20} weight="bold" className="text-gray-800" />
        </button>
        <Image
          src={CalenderIllustration}
          alt="Kalender Illustration"
          width={92}
          height={74}
          className="absolute -top-6.5 left-1/2 hidden -translate-x-1/2 md:block"
        />
        <div className="flex items-center justify-between md:flex-col md:items-start">
          <div className="md:w-full">
            <p className="text-xs md:text-center md:text-sm">
              Teste uns mit einer Probelektion!
            </p>
            <p className="text-lg font-black md:text-center md:text-2xl">
              59 CHF
            </p>
          </div>
          <Button
            as={Link}
            href={link.url}
            version="pink"
            className="ml-6 shadow-sm md:mt-3 md:ml-0 md:w-full"
          >
            Jetzt buchen
          </Button>
        </div>
      </div>
      <div
        className={clsx(
          'insert-x-0 fixed bottom-0 z-50 w-full origin-bottom border-t border-gray-150 bg-gray-25/90 py-4 backdrop-blur-xs transition-all duration-500 md:hidden',
          {
            'pointer-events-none translate-y-1/2 opacity-0': !scrolled2,
            'translate-y-0 opacity-100': scrolled2,
          }
        )}
      >
        <Link
          href={link.url}
          className="flex w-full items-center justify-center"
        >
          <p className="text-sm">
            Probelektion online buchen für{' '}
            <span className="font-bold">nur 59 CHF</span>
          </p>
          <CaretRight
            size={16}
            weight="bold"
            className="ml-1 shrink-0 text-gray-800"
          />
        </Link>
      </div>
    </>
  )
}
